// extracted by mini-css-extract-plugin
export var box = "_3z-1";
export var checkboxRow = "_3z-8";
export var checked = "_3z-2";
export var descriptionSpacer = "_3z-a";
export var disabled = "_3z-3";
export var icon = "_3z-6";
export var input = "_3z-0";
export var labelSpacer = "_3z-9";
export var medium = "_3z-5";
export var small = "_3z-4";
export var text = "_3z-7";